import AICreateFormPage from '@/views/forms/AICreateFormPage'

export default function AICreateFormScreen() {
  return <AICreateFormPage />
}
